module.exports = __webpack_public_path__ + "fonts/SamsungOne-600v10.5c1169b0.otf";